module.exports = __webpack_public_path__ + "assets/img/about-1.d714e114.png";